import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function CtaSection() {
  return (
    <section className="cta-section" id="diagnostico">
      <Container>
        <Row className="justify-content-center text-center">
          <Col md={8}>
            <h2 className="cta-heading">Quer receber um diagnóstico da sua empresa?</h2>
            <p className="cta-subheading">
              Enviamos um relatório com a nossa percepção sobre a qualidade da operação financeira da sua empresa e os principais pontos de atenção.
            </p>
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSdQ21gI0-BMmT5bIeIRUjkDYdtK3fU-fbgiiSlXpQuhdbdqzQ/viewform"
              className="home-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Solicitar Orçamento
            </a>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default CtaSection;
